'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Banner401k = require('./Banner401k.css');

var _Banner401k2 = _interopRequireDefault(_Banner401k);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner401k = (_dec = (0, _reactCssModules2.default)(_Banner401k2.default, { allowMultiple: false }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Banner401k, _Component);

  function Banner401k() {
    (0, _classCallCheck3.default)(this, Banner401k);
    return (0, _possibleConstructorReturn3.default)(this, (Banner401k.__proto__ || (0, _getPrototypeOf2.default)(Banner401k)).apply(this, arguments));
  }

  (0, _createClass3.default)(Banner401k, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'hh-img-bckgrnd' },
        _react2.default.createElement(
          'div',
          { styleName: 'hh-img-bckgrnd-gray' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'hh-hl' },
              'Your retirement plan may be fueling the climate crisis. But it doesn\'t have to.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hh-tl' },
              'See how 401(k)s or similar employee retirement plans of S&P 500 companies are rated on seven environmental and social sustainability issues.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hh-button' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.iyv,
                  title: 'Retirement plan sustainability scorecard',
                  bigbutton: true
                },
                'See 401(k) ratings',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    }
  }]);
  return Banner401k;
}(_react.Component)) || _class);
exports.default = Banner401k;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Banner401k/Banner401k.js
// module id = 1348
// module chunks = 0